module.exports = __webpack_public_path__ + "img/calendarMinus.d3cd0f6f.svg";